import {
  CategoryTypeUploadEnum,
  IDataResponseModel,
  IUploadFile,
} from "@/models";
import { ApiConstant, AppConstant, EnvConstant } from "@/const";
import { enqueueSnackbar } from "notistack";
import { uploadFileServices } from "@/services";

const useHandleUploadFile = () => {
  const handleUploadFile = async (
    fileArr: Array<File>,
    categoryType: CategoryTypeUploadEnum,
    ownerId: string,
    isShowMessage: boolean = true
  ): Promise<IUploadFile[]> => {
    const listPromisse = [];
    for (let file of fileArr) {
      listPromisse.push(
        handleUploadOneFile(file, categoryType, ownerId, isShowMessage)
      );
    }
    const result: IUploadFile[] = [];
    await Promise.all(listPromisse).then((res) => {
      result.push(...res.filter((c) => c !== null));
    });
    return result;
  };
  const handleUploadOneFile = async (
    file: File,
    categoryType: CategoryTypeUploadEnum,
    ownerId: string,
    isShowMessage: boolean = true
  ): Promise<IUploadFile | null> => {
    ownerId = ownerId || "";
    try {
      const formData: FormData = new FormData();
      // formData.append("category_id", categoryType);
      formData.append("file", file);

      const response: IDataResponseModel<IUploadFile> =
        await uploadFileServices.uploadFile(formData, categoryType, ownerId);

      const responseData = response.payload;
      if (response.status !== ApiConstant.STT_OK) {
        return null;
      } else {
        if (isShowMessage) {
          enqueueSnackbar({
            variant: AppConstant.SUCCEED_VARIANT,
            message: "Tải file thành công!",
          });
        }
        return responseData.data || null;
      }
    } catch (error: any) {
      EnvConstant.IS_DEV && console.log(error);
      return null;
    }
  };
  const handleDeleteFile = async (
    id: string,
    categoryType: CategoryTypeUploadEnum,
    isShowMessage: boolean = true
  ) => {
    try {
      const formData: FormData = new FormData();
      formData.append("category_id", categoryType);

      const response: IDataResponseModel<boolean> =
        await uploadFileServices.deleteFile(id, categoryType);

      const responseData = response.payload;
      if (response.status !== ApiConstant.STT_OK) {
        if (isShowMessage) {
          enqueueSnackbar({
            variant: AppConstant.ERROR_VARIANT,
            message: responseData.message || "Xóa file không thành công!",
          });
        }
        return false;
      } else {
        if (isShowMessage) {
          enqueueSnackbar({
            variant: AppConstant.SUCCEED_VARIANT,
            message: "Tải file thành công!",
          });
        }
        return responseData.data;
      }
    } catch (error: any) {
      EnvConstant.IS_DEV && console.log(error);
      if (isShowMessage) {
        enqueueSnackbar({
          variant: AppConstant.ERROR_VARIANT,
          message:
            error?.response?.data?.message || "Xóa file không thành công!",
        });
      }
      return false;
    }
  };

  return { handleUploadFile, handleDeleteFile };
};

export default useHandleUploadFile;
